export const listTabDepartingVisitor = [
    {
        key: "demographic",
        title: "Demographic Details",
        status: 0
    },
    {
        key: "travel",
        title: "Travel Details",
        status: 0
    },
    {
        key: "entry_point",
        title: "Entry Point Details",
        status: 0
    },
    {
        key: "air_entry_point",
        title: "By Air Entry Point Details",
        status: 0
    },
    {
        key: "travel_arrangement",
        title: "Travel Arrangement Details",
        status: 0
    },
    {
        key: "expense",
        title: "Self Arranged, Package Tour & Travel Expenses Details",
        status: 0
    },
    {
        key: "vacation",
        title: "Holiday/Vacation Details",
        status: 0
    },
    {
        key: "feedbacks",
        title: "Comments or Feedbacks",
        status: 0
    },
];

export const DEPARTING_ENUM = {
    FORM_1: "demographic",
    FORM_2: "travel",
    FORM_3: "entry_point",
    FORM_4: "air_entry_point",
    FORM_5: "travel_arrangement",
    FORM_6: "expense",
    FORM_7: "vacation",
    FORM_8: "feedbacks",
}

export const listTabSabahOutbound = [
    {
        key: "demographic",
        title: "Demographic Details",
        status: 0
    },
    {
        key: "travel",
        title: "Travel Details",
        status: 0
    },
    {
        key: "expense",
        title: "Travel Expenses Details",
        status: 0
    },
    {
        key: "air_entry_point",
        title: "By Air Entry Point Details",
        status: 0
    },
];

export const OUTBOUND_ENUM = {
    FORM_1: "demographic",
    FORM_2: "travel",
    FORM_4: "expense",
    FORM_5: "air_entry_point",
}
